import axios from "axios";
import api from '../../axios/api';
import * as actionTypes from './actionTypes';
import { IUser } from "../../models/iuser";
import { fetchUserService, fetchValidUsersService } from "../../services/users";
import { ISite } from "../../models/isite";
import { IRole } from "../../models/irole";
import siteObjectToQuery from "../../utils/siteObjectToQuery";
import filterObjectToQuery from "../../utils/filterObjectToQuery";
import { ICountByUserAndDay, IEquipmentServiceTobeScheduled, IFilter, IScheduledServiceCalendarEventResponse, IScheduledServiceState } from "../reducers/scheduledServices";
import { toastr } from "react-redux-toastr";
import { i18n } from "../../translate/i18n";
import { IScheduledService } from "../../models/ischeduledService";
import { fetchPlacesLeafsService } from '../../services/places';
import { fetchEquipmentModelsService } from '../../services/equipmentModes';
import { fetchGroupsServices } from '../../services/groups';
import { fetchAreas } from '../../services/areas';
import { fetchCompaniesService } from '../../services/companies';

import { IPlace } from "../../models/iplace";
import { IEquipmentGroup } from "../../models/iequipmentGroup";
import { IEquipmentModel } from "../../models/iequipmentModel";
import { ICompany } from "../../models/icompany";
import { IFrequency } from "../../models/ifrequency";
import { IServiceType } from "../../models/iserviceType";
import { IArea } from "../../models/iarea";
import { EFilterType } from "../reducers/scheduledServices";
import { IAutocompleteOption } from "../../models/iautocompleteOption";
import { IEquipment } from "../../models/iequipment";
import { fetchEquipmentsService } from "../../services/equipments";
import { EServiceStatus, IEquipmentOption } from "../../containers/ScheduledServices/ScheduledServicesPlanner/Modals/ServicesForSchedulingFiltersModal";

const CancelToken = axios.CancelToken;

let fetchServicesForScheduling_cancel: any;

export type IPostScheduledServiceBody = {
  accountables: string[],
  equipment: string,
  equipmentModelName: string,
  equipmentModelId: string,
  equipmentServiceId: string,
  expirationDate: null | Date,
  frequency: {
    _id: string,
    name: string,
  },
  serviceType: {
    _id: string,
    name: string,
  },
  scheduledDate: Date,
  site: string,
  place: string,
}

export type IUpdateScheduledServiceBody = {
  accountables: string[],
  scheduledDate: Date,
};

const fetchUsersScheduledServicesStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_USERS_START,
  }
}

const fetchUsersScheduledServicesSuccess = (users: IUser[]) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_USERS_SUCCESS,
    payload: users,
    
  }
}

const fetchUsersScheduledServicesFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_USERS_FAIL,
  }
}

export const fetchUsersScheduledServices = (page: number, limit: number, search: string, order: string, orderBy: string, siteId: string, roles: IRole[], companies: IRole[]) => {
  return (dispatch: any) => {
    dispatch(fetchUsersScheduledServicesStart());
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `${siteId !== '' ? '&sites=' + siteId : ''}`;
    queryParams += `${roles && roles.length > 0 ? '&roles=' + filterObjectToQuery(roles) : ''}`
    queryParams += `${companies && companies.length > 0 ? '&companies=' + filterObjectToQuery(companies) : ''}`
    api.get('/users' + queryParams)
      .then((res) => {
        dispatch(fetchUsersScheduledServicesSuccess(res.data.rows));
      })
      .catch(err => {
        console.error(err)
        dispatch(fetchUsersScheduledServicesFail());
      });
  };
};


const fetchServicesForSchedulingStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_START,
  }
}

const fetchServicesForSchedulingSuccess = (response: {services: IScheduledServiceState[], count: number}) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_SUCCESS,
    payload: response,
    
  }
}

const fetchServicesForSchedulingFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_FAIL,
  }
}

const fetchMoreServicesForSchedulingStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_START,
  }
}

const fetchMoreServicesForSchedulingSuccess =  (response: {services: IScheduledServiceState[], count: number}) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_SUCCESS,
    payload: response,    
  }
}

const fetchMoreServicesForSchedulingFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_FAIL,
  }
}

export const fetchServicesForScheduling = (
  page: number,
  limit: number,
  search: string,
  siteId: string,
  places: IFilter[],
  equipmentModels: IFilter[],
  equipmentGroups: IFilter[],
  areas: IFilter[],
  companies: IFilter[],
  serviceTypes: IFilter[],
  frequencies: IFilter[],
  startDate: Date | null,
  endDate: Date | null,
  equipment: IEquipmentOption|null,
  isLoadMore: boolean = false,
  serviceStatus: EServiceStatus[],
) => {
  fetchServicesForScheduling_cancel && fetchServicesForScheduling_cancel();
  return (dispatch: any) => {
    isLoadMore ?  dispatch(fetchMoreServicesForSchedulingStart()) : dispatch(fetchServicesForSchedulingStart());

    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}`;
    // queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
    queryParams += `${siteId !== '' ? '&sites=' + siteId : ''}`;
    queryParams += `${equipmentModels && equipmentModels.length > 0 ? '&models=' + filterObjectToQuery(equipmentModels) : ''}`;
    queryParams += `${places && places.length > 0 ? '&leafs=' + filterObjectToQuery(places) : ''}`
    queryParams += `${equipmentGroups && equipmentGroups.length > 0 ? '&groups=' + filterObjectToQuery(equipmentGroups) : ''}`;
    queryParams += `${areas && areas.length > 0 ? '&areas=' + filterObjectToQuery(areas) : ''}`;
    queryParams += `${companies && companies.length > 0 ? '&companies=' + filterObjectToQuery(companies) : ''}`;
    queryParams += `${frequencies && frequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(frequencies) : ''}`;
    queryParams += `${serviceTypes && serviceTypes.length > 0 ? '&service_types=' + filterObjectToQuery(serviceTypes) : ''}`;
    queryParams += `${startDate ? `&after=${startDate.toISOString()}` : ''}`
    queryParams += `${endDate ? `&before=${endDate.toISOString()}` : ''}`
    queryParams += `${equipment ? '&equipments=' + equipment.value : ''}`
    queryParams += `${serviceStatus.length > 0 ? '&serviceStatus=' + serviceStatus.join(',') : ''}`

    api.get(`/scheduledservices/servicesforscheduling${queryParams}`, {
      cancelToken: new CancelToken(function executor(c) {
        fetchServicesForScheduling_cancel = c;
      })
    })
      .then((res) => {
        isLoadMore ? dispatch(fetchMoreServicesForSchedulingSuccess(res.data)) : dispatch(fetchServicesForSchedulingSuccess(res.data));
      })
      .catch(err => {
        console.error(err)
        isLoadMore ? dispatch(fetchMoreServicesForSchedulingFail()) : dispatch(fetchServicesForSchedulingFail());
      });
  };
};

export const scheduledServicesSetServicesForSchedulingFilters = (filters: IScheduledServiceState['filtersServicesForScheduling']) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SET_SERVICES_FOR_SCHEDULING_FILTERS,
    payload: filters,
  }
}

export const scheduledServicesClearServicesForSchedulingFilters = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CLEAR_SERVICES_FOR_SCHEDULING_FILTERS,
  }
}

const postScheduledServiceStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_POST_START,
  }
}

const postScheduledServiceSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_POST_SUCCESS,
  }
}

const postScheduledServiceFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_POST_FAIL,
  }
}

export const postScheduledService = (
  body: { services: IPostScheduledServiceBody[]},
  page: number,
  limit: number,
  search: string,
  siteId: string,
  places: IFilter[],
  equipmentModels: IFilter[],
  equipmentGroups: IFilter[],
  areas: IFilter[],
  companies: IFilter[],
  serviceTypes: IFilter[],
  frequencies: IFilter[],
  startDate: Date | null,
  endDate: Date | null,
  equipment: IEquipmentOption|null,
  serviceStatus: EServiceStatus[],
) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(postScheduledServiceStart());
      api.post('/scheduledservices', body)
        .then(res => {
          dispatch(postScheduledServiceSuccess());
          dispatch(fetchServicesForScheduling(page, limit, search, siteId, places, equipmentModels, equipmentGroups, areas, companies, serviceTypes, frequencies, startDate, endDate, equipment, false, serviceStatus));
          dispatch(countScheduledServicesByUsersAndDays());
          const message = body.services.length > 1 ? i18n.t('scheduledServicesStore.scheduledServicesCreated') : i18n.t('scheduledServicesStore.scheduledServiceCreated')
          toastr.success(`${body.services.length} ${message}`, '');
          resolve('success');
        })
        .catch(err => {
          dispatch(postScheduledServiceFail());
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
}

const countScheduledServicesByUsersAndDaysStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_START,
  }
}

const countScheduledServicesByUsersAndDaysSuccess = (servicesByUsers: ICountByUserAndDay[]) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_SUCCESS,
    payload: servicesByUsers,
  }
}

const countScheduledServicesByUsersAndDaysFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_FAIL,
  }
}

export const countScheduledServicesByUsersAndDays = () => {
  return (dispatch: any) => {
    dispatch(countScheduledServicesByUsersAndDaysStart())
    api.get('/scheduledservices/countbyusersanddays')
      .then((res) => {
        dispatch(countScheduledServicesByUsersAndDaysSuccess(res.data.scheduledServicesByUser));
      })
      .catch(err => {
        console.error(err)
        dispatch(countScheduledServicesByUsersAndDaysFail());
      });
  };
};

const fetchScheduledServicesByUserAndDayStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_START,
  }
}

const fetchScheduledServicesByUserAndDaySuccess = (scheduledServices: IScheduledService[]) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_SUCCESS,
    payload: scheduledServices,
  }
}

const fetchScheduledServicesByUserAndDayFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_FAIL,
  }
}

export const fetchScheduledServicesByUserAndDay = (userId: string, date: string) => {
  return (dispatch: any) => {
    dispatch(fetchScheduledServicesByUserAndDayStart())
    api.get(`/scheduledservices/${userId}/${date}`)
      .then((res) => {
        dispatch(fetchScheduledServicesByUserAndDaySuccess(res.data));
      })
      .catch(err => {
        console.error(err)
        dispatch(fetchScheduledServicesByUserAndDayFail());
      });
  };
};

export const scheduledServicesOpenCloseServicesByUserAndDayModal = (showCompletedOnly?: boolean) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_OPEN_CLOSE_SERVICES_BY_USER_AND_DAY_MODAL,
    payload: showCompletedOnly || false,
  }
}

export const scheduledServicesSelectUserAndDate = (userAndDate: { userId: string, date: string }) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SELECT_USER_AND_DATE,
    payload: userAndDate,
  }
}

const softDeleteScheduledServiceStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_START,
  }
}

const softDeleteScheduledServiceSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_SUCCESS,
  }
}

const softDeleteScheduledServiceFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_FAIL,
  }
}

export const softDeleteScheduledService = (scheduledServiceId: string, userId: string, date: string) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(softDeleteScheduledServiceStart());
      api.patch(`/scheduledservices/delete/${scheduledServiceId}`)
        .then(res => {
          dispatch(softDeleteScheduledServiceSuccess());
          dispatch(fetchScheduledServicesByUserAndDay(userId, date));
          dispatch(countScheduledServicesByUsersAndDays());
          toastr.success(i18n.t('scheduledServicesStore.scheduledServiceDeleted'), '');
          resolve('success');
        })
        .catch(err => {
          dispatch(softDeleteScheduledServiceFail());
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
}

export const scheduledServicesSetUsersFilters = (usersFilters: IScheduledServiceState['filtersUsers']) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SET_USERS_FILTERS,
    payload: usersFilters,
  }
}

export const scheduledServicesClearUsersFilters = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CLEAR_USERS_FILTERS,
  }
}

const fetchPlacesStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_START
  };
};

const fetchPlacesSuccess = (places: IPlace[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_SUCCESS,
    payload: places,
  };
};

const fetchPlacesFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_FAIL,
  };
};


export const scheduledServicesFetchPlaces = (siteId: string) => {
  return (dispatch: any) => {
    dispatch(fetchPlacesStart());
    const query = `?sites=${siteId}`;
    api.get('/places/leafs' + query)
      .then((res: any) => {
        dispatch(fetchPlacesSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchPlacesFail());
      });
  };
};

const fetchEquipmentModelsStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_START
  };
};

const fetchEquipmentModelsSuccess = (equipmentModels: IEquipmentModel[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_SUCCESS,
    payload: equipmentModels,
  };
};

const fetchEquipmentModelsFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_FAIL,
  };
};


export const scheduledServicesFetchEquipmentModels = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchEquipmentModelsStart());
    fetchEquipmentModelsService(page, limit, search, order, orderBy, '')
      .then((res: any) => {
        dispatch(fetchEquipmentModelsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchEquipmentModelsFail());
      });
  };
};

const fetchEquipmentsStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENTS_START
  };
};

const fetchEquipmentsSuccess = (equipments: IEquipment[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENTS_SUCCESS,
    payload: equipments,
  };
};

const fetchEquipmentsFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_EQUIPMENTS_FAIL,
  };
};


export const scheduledServicesFetchEquipments = (page: number, limit: number, search: string, order: string, orderBy: string, sites: ISite[], filteredPlaces: IAutocompleteOption[], filteredModels: IAutocompleteOption[], filteredGroups: IAutocompleteOption[], filteredAreas: IAutocompleteOption[], filteredCompanies: IAutocompleteOption[]) => {
  return (dispatch: any) => {
    dispatch(fetchEquipmentsStart());
    fetchEquipmentsService(page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, false, false)
      .then((res: any) => {
        dispatch(fetchEquipmentsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchEquipmentsFail());
      });
  };
};

const fetchGroupsStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_GROUPS_START,
  };
};

const fetchGroupsSuccess = (groups: IEquipmentGroup[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_GROUPS_SUCCESS,
    payload: groups,
  };
};

const fetchGroupsFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_GROUPS_FAIL,
  };
};


export const scheduledServicesFetchGroups = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchGroupsStart());
    fetchGroupsServices(page, limit, search, order, orderBy, '')
      .then((res: any) => {
        dispatch(fetchGroupsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchGroupsFail());
      });
  };
};

const fetchAreasStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_AREAS_START
  };
};

const fetchAreasSuccess = (areas: IArea[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_AREAS_SUCCESS,
    payload: areas,
  };
};

const fetchAreasFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_AREAS_FAIL,
  };
};


export const scheduledServicesFetchAreas = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchAreasStart());
    fetchAreas(page, limit, search, order, orderBy)
      .then((res: any) => {
        dispatch(fetchAreasSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchAreasFail());
      });
  };
};

const fetchCompaniesStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_COMPANIES_START
  };
};

const fetchCompaniesSuccess = (companies: ICompany[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_COMPANIES_SUCCESS,
    payload: companies,
  };
};

const fetchCompaniesFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_COMPANIES_FAIL,
  };
};


export const scheduledServicesFetchCompanies = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchCompaniesStart());
    fetchCompaniesService(page, limit, search, order, orderBy)
      .then((res: any) => {
        dispatch(fetchCompaniesSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchCompaniesFail());
      });
  };
};

const fetchFrequenciesStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_FREQUENCIES_START
  };
};

const fetchFrequenciesSuccess = (frequencies: IFrequency[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_FREQUENCIES_SUCCESS,
    payload: frequencies,
  };
};

const fetchFrequenciesFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_FREQUENCIES_FAIL,
  };
};

export const scheduledServicesFetchFrequencies = (page: number, limit: number, search: string, order: string, orderBy: string) => {

  return (dispatch: any) => {
    dispatch(fetchFrequenciesStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    api.get('/frequency' + queryParams)
      .then(res => {
        dispatch(fetchFrequenciesSuccess(res.data.rows));
      })
      .catch(err => {
        console.error(err);
        dispatch(fetchFrequenciesFail());
      });
  };
};

const fetchServiceTypesStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_START
  };
};

const fetchServiceTypesSuccess = (serviceTypes: IServiceType[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_SUCCESS,
    payload: serviceTypes,
  };
};

const fetchServiceTypesFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_FAIL,
  };
};

export const scheduledServicesFetchServiceTypes = (page: number, limit: number, search: string, order: string, orderBy: string) => {

  return (dispatch: any) => {
    dispatch(fetchServiceTypesStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    api.get('/servicetypes' + queryParams)
      .then(res => {
        dispatch(fetchServiceTypesSuccess(res.data.rows));
      })
      .catch(err => {
        console.error(err);
        dispatch(fetchServiceTypesFail());
      });
  };
};

const fetchUsersStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_USERS_START
  };
};

const fetchUsersSuccess = (users: IUser[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_USERS_SUCCESS,
    payload: users,
  };
};

const fetchUsersFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_USERS_FAIL,
  };
};

export const scheduledServicesFetchValidUsers = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchUsersStart());
    fetchValidUsersService(page, limit, search, order, orderBy)
      .then(res => {
        dispatch(fetchUsersSuccess(res.data.rows));
      })
      .catch(err => {
        console.error(err);
        dispatch(fetchUsersFail());
      });
  };
};

export const scheduledServicesSelectSite = (siteId: string) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SELECT_SITE,
    payload: siteId,
  }
};

// CALENDAR

export const scheduledServicesClearCalendarFilters = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CLEAR_CALENDAR_FILTERS,
  }
}

export const scheduledServicesClearCalendarSelectedFilter = (filterId: string, type: EFilterType) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CLEAR_CALENDAR_SELECTED_FILTER,
    payload: {
      id: filterId,
      type,
    }
  }
}

export const scheduledServicesSetCalendarsFilters = (filters: IScheduledServiceState['calendar']['filters']) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SET_CALENDARS_FILTERS,
    payload: filters,
  }
}

const fetchPlacesCalendarStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_START
  };
};

const fetchPlacesCalendarSuccess = (places: IPlace[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_SUCCESS,
    payload: places,
  };
};

const fetchPlacesCalendarFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_FAIL,
  };
};


export const scheduledServicesFetchPlacesCalendar = (sites: ISite[]) => {
  return (dispatch: any) => {
    dispatch(fetchPlacesCalendarStart());
    fetchPlacesLeafsService(sites)
      .then((res: any) => {
        dispatch(fetchPlacesCalendarSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchPlacesCalendarFail());
      });
  };
};

const fetchCalendarEventsStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_START
  };
};

const fetchCalendarEventsSuccess = (events: IScheduledServiceCalendarEventResponse[]) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_SUCCESS,
    payload: events,
  };
};

const fetchCalendarEventsFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_FAIL,
  };
};


export const scheduledServicesFetchCalendarEvents = (
  date: string,
  sites: ISite[],
  users: IAutocompleteOption[],
  equipmentGroups: IAutocompleteOption[],
  equipmentModels: IAutocompleteOption[],
  areas: IAutocompleteOption[],
  places: IAutocompleteOption[],
  companies: IAutocompleteOption[],
  serviceTypes: IAutocompleteOption[],
  frequencies: IAutocompleteOption[],
) => {
  return (dispatch: any) => {
    let query = `?date=${date}`;
    query += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
    query += users.length > 0 ? `&users=${filterObjectToQuery(users)}` : '';
    query += equipmentGroups.length > 0 ? `&groups=${filterObjectToQuery(equipmentGroups)}` : '';
    query += equipmentModels.length > 0 ? `&models=${filterObjectToQuery(equipmentModels)}` : '';
    query += areas.length > 0 ? `&areas=${filterObjectToQuery(areas)}` : '';
    query += places.length > 0 ? `&places=${filterObjectToQuery(places)}` : '';
    query += companies.length > 0 ? `&companies=${filterObjectToQuery(companies)}` : '';
    query += serviceTypes.length > 0 ? `&service_types=${filterObjectToQuery(serviceTypes)}` : '';
    query += frequencies.length > 0 ? `&frequencies=${filterObjectToQuery(frequencies)}` : '';
    dispatch(fetchCalendarEventsStart());
    api.get(`/scheduledservices/calendar${query}`)
      .then((res: any) => {
        dispatch(fetchCalendarEventsSuccess(res.data));
      })
      .catch( () => {
        dispatch(fetchCalendarEventsFail());
      });
  };
};

export const scheduledServicesSelectCalendarEvent = (date: string, completed: boolean, borderColor: string, title: string) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CALENDAR_SELECT_EVENT,
    payload: {
      date,
      completed,
      borderColor,
      title,
    }
  }
}

const fetchServicesByDayAndCompletedStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_START,
  };
};

const fetchServicesByDayAndCompletedSuccess = (services: IScheduledService[] ) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_SUCCESS,
    payload: services,
  };
};

const fetchServicesByDayAndCompletedFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_FAIL,
  };
};


export const scheduledServicesFetchServicesByDayAndCompleted = (
  date: string,
  completed: boolean,
  sites: ISite[],
  users: IAutocompleteOption[],
  equipmentGroups: IAutocompleteOption[],
  equipmentModels: IAutocompleteOption[],
  areas: IAutocompleteOption[],
  places: IAutocompleteOption[],
  companies: IAutocompleteOption[],
  serviceTypes: IAutocompleteOption[],
  frequencies: IAutocompleteOption[],
) => {
  return (dispatch: any) => {
    dispatch(fetchServicesByDayAndCompletedStart());
    let query = `?date=${date}&completed=${completed}`;
    query += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
    query += users.length > 0 ? `&users=${filterObjectToQuery(users)}` : '';
    query += equipmentGroups.length > 0 ? `&groups=${filterObjectToQuery(equipmentGroups)}` : '';
    query += equipmentModels.length > 0 ? `&models=${filterObjectToQuery(equipmentModels)}` : '';
    query += areas.length > 0 ? `&areas=${filterObjectToQuery(areas)}` : '';
    query += places.length > 0 ? `&places=${filterObjectToQuery(places)}` : '';
    query += companies.length > 0 ? `&companies=${filterObjectToQuery(companies)}` : '';
    query += serviceTypes.length > 0 ? `&service_types=${filterObjectToQuery(serviceTypes)}` : '';
    query += frequencies.length > 0 ? `&frequencies=${filterObjectToQuery(frequencies)}` : '';
    api.get(`/scheduledservices/bydateandcompleted${query}`)
      .then((res: any) => {
        dispatch(fetchServicesByDayAndCompletedSuccess(res.data));
      })
      .catch( () => {
        dispatch(fetchServicesByDayAndCompletedFail());
      });
  };
};

export const scheduledServicesToggleShowSelectManyCheckBoxes = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_TOGGLE_SHOW_SELECT_MANY_CHECKBOXES,
  }
}

export const scheduledServicesAddSelectedServiceToBeScheduled = (serviceTobeScheduled: IEquipmentServiceTobeScheduled) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_ADD_SERVICE_TO_BE_SCHEDULED,
    payload: serviceTobeScheduled,
  }
}

export const scheduledServicesRemoveSelectedServiceToBeScheduled = (serviceTobeRemoved: IEquipmentServiceTobeScheduled) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_REMOVE_SERVICE_TO_BE_SCHEDULED,
    payload: serviceTobeRemoved,
  }
}

export const scheduledServicesClearSelectedServicesTobeScheduled = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_CLEAR_SERVICES_TO_BE_SCHEDULED,
  }
}

export const scheduledServicesAddAllSelectedServicesTobeScheduled = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_ADD_ALL_SERVICES_TO_BE_SCHEDULED,
  }
}

const fetchUsersForModalStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_FETCH_USERS_START,
  };
};

const fetchUsersForModalSuccess = (users: IUser[]) => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_FETCH_USERS_SUCCESS,
    payload: users,
  };
};

const fetchUsersForModalFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_FETCH_USERS_FAIL,
  };
};

export const fetchUsersForModal = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchUsersForModalStart());
    fetchUserService(page, limit, search, order, orderBy, [], [])
      .then(res => {
        dispatch(fetchUsersForModalSuccess(res.data.rows));
      })
      .catch(err => {
        dispatch(fetchUsersForModalFail());
      });
  };
};

const postScheduledServiceModalStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_POST_START,
  };
};

const postScheduledServiceModalSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_POST_SUCCESS,
  };
};

const postScheduledServiceModalFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_POST_FAIL,
  };
};

export const postScheduledServiceModal = (body: { services: IPostScheduledServiceBody[]},) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(postScheduledServiceModalStart());
      api.post('/scheduledservices', body)
        .then(res => {
          dispatch(postScheduledServiceModalSuccess());
          const message = i18n.t('scheduledServicesStore.scheduledServiceCreated')
          toastr.success(`${body.services.length} ${message}`, '');
          resolve('success');
        })
        .catch(err => {
          dispatch(postScheduledServiceModalFail());
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
};

const updateScheduledServiceModalStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_UPDATE_START,
  };
};

const updateScheduledServiceModalSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_UPDATE_SUCCESS,
  };
};

const updateScheduledServiceModalFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_MODAL_UPDATE_FAIL,
  };
};

export const updateScheduledServiceModal = (body: IUpdateScheduledServiceBody, scheduledServiceId: string) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(updateScheduledServiceModalStart());
      api.put(`/scheduledservices/${scheduledServiceId}`, body)
        .then(res => {
          dispatch(updateScheduledServiceModalSuccess());
          const message = i18n.t('scheduledServicesStore.scheduledServiceUpdated')
          toastr.success(message,'');
          resolve('success');
        })
        .catch(err => {
          dispatch(updateScheduledServiceModalFail());
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
};

const softDeleteCalendarScheduledServiceStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_START,
  }
}

const softDeleteCalendarScheduledServiceSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_SUCCESS,
  }
}

const softDeleteCalendarScheduledServiceFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_SOFT_DELETE_FAIL,
  }
}

export const softDeleteCalendarScheduledService = (
  scheduledServiceId: string,
  date: string,
  completed: boolean,
  sites: ISite[],
  users: IAutocompleteOption[],
  equipmentGroups: IAutocompleteOption[],
  equipmentModels: IAutocompleteOption[],
  areas: IAutocompleteOption[],
  places: IAutocompleteOption[],
  companies: IAutocompleteOption[],
  serviceTypes: IAutocompleteOption[],
  frequencies: IAutocompleteOption[],
) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(softDeleteCalendarScheduledServiceStart());
      api.patch(`/scheduledservices/delete/${scheduledServiceId}`)
        .then(res => {
          dispatch(softDeleteCalendarScheduledServiceSuccess());
          dispatch(scheduledServicesFetchServicesByDayAndCompleted(date, completed, sites, users, equipmentGroups, equipmentModels, areas,places, companies, serviceTypes, frequencies))
          dispatch(scheduledServicesFetchCalendarEvents(date, sites, users, equipmentGroups, equipmentModels, areas,places, companies, serviceTypes, frequencies));
          toastr.success(i18n.t('scheduledServicesStore.scheduledServiceDeleted'), '');
          resolve('success');
        })
        .catch(err => {
          dispatch(softDeleteCalendarScheduledServiceFail());
          toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })

  }
}

const fetchCalendarReportStart = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_START
  };
};

const fetchCalendarReportSuccess = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_SUCCESS,
  };
};

const fetchCalendarReportFail = () => {
  return {
    type: actionTypes.SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_FAIL,
  };
};

export const scheduledServicesFetchCalendarReportExcell = (
  date: string,
  sites: ISite[],
  users: IAutocompleteOption[],
  equipmentGroups: IAutocompleteOption[],
  equipmentModels: IAutocompleteOption[],
  areas: IAutocompleteOption[],
  places: IAutocompleteOption[],
  companies: IAutocompleteOption[],
  serviceTypes: IAutocompleteOption[],
  frequencies: IAutocompleteOption[],
  language: string,
) => {
  return (dispatch: any): Promise<string> => {
    return new Promise ((resolve, reject) => {
      let query = `?date=${date}`;
      query += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      query += users.length > 0 ? `&users=${filterObjectToQuery(users)}` : '';
      query += equipmentGroups.length > 0 ? `&groups=${filterObjectToQuery(equipmentGroups)}` : '';
      query += equipmentModels.length > 0 ? `&models=${filterObjectToQuery(equipmentModels)}` : '';
      query += areas.length > 0 ? `&areas=${filterObjectToQuery(areas)}` : '';
      query += places.length > 0 ? `&places=${filterObjectToQuery(places)}` : '';
      query += companies.length > 0 ? `&companies=${filterObjectToQuery(companies)}` : '';
      query += serviceTypes.length > 0 ? `&service_types=${filterObjectToQuery(serviceTypes)}` : '';
      query += frequencies.length > 0 ? `&frequencies=${filterObjectToQuery(frequencies)}` : '';
      query += `&language=${language}`;
      dispatch(fetchCalendarReportStart());
      api.get(`/scheduledservices/reportCalendarExcell${query}`)
        .then((res: any) => {
          dispatch(fetchCalendarReportSuccess());
          resolve(res.data.url);
        })
        .catch((e) => {
          dispatch(fetchCalendarReportFail());
          reject(e);
        });
    })
  };
};
